import React from 'react';
import CardSaleSuccess from 'components/atoms/card_sale_success';

const SaleSuccess: React.FC = () => {
  return (
    <div className="page-container">
      <CardSaleSuccess />
    </div>
  );
};
export { SaleSuccess };
